import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4
};

export default function Login({
    onStartLogin
}) {

  return (
    <div>
      <Modal
        open={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style} justifyContent="center" justifyItems="center">
          <Typography id="modal-modal-title" variant="h3" component="h2">
            Meetings Agent
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Please login to continue
          </Typography>
          <Button onClick={onStartLogin}>Login</Button>
        </Box>
      </Modal>
    </div>
  );
}
